import { User } from "../core";
Office.onReady(async (info) => {
  if (info.host !== Office.HostType.Outlook) return;
  
  try {
    await User.login(() => {
      User.createCard()
    }); 
  } catch (e) {
    console.error("Initialization failed:", e);
  }
});